import React from 'react';
import { getThemeColor } from '../../config/appConfig';

const THEME = getThemeColor('primary');
const THEME_LIGHT = '#b91c1c';
const THEME_SOFT = '#fef2f2';
const GREEN = '#22C55E';
const ORANGE = '#F59E0B';
const stroke = { fill: 'none', strokeWidth: 1.75, strokeLinecap: 'round', strokeLinejoin: 'round' };

const icons = {
  statTotalReferrals: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="9" r="3" stroke={color} {...stroke} />
      <path d="M4 19c0-3 2.2-5.5 5-5.5s5 2.5 5 5.5" stroke={color} {...stroke} />
      <circle cx="16.5" cy="9.5" r="2.5" stroke={color} {...stroke} />
      <path d="M14 19c.8-2 2.2-3.5 4.5-3.5 1.2 0 2.2.4 3 1" stroke={color} {...stroke} />
    </svg>
  ),
  statTotalRevenue: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M4 8.5V18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.5" stroke={color} {...stroke} />
      <path d="M3 8.5h18" stroke={color} {...stroke} />
      <path d="M16 8.5V6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2.5" stroke={color} {...stroke} />
      <path d="M12 12v4" stroke={color} {...stroke} />
    </svg>
  ),
  statPaidEarnings: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M8 10c0-3 1.8-5.5 4-5.5s4 2.5 4 5.5" stroke={color} {...stroke} />
      <path d="M6 10v2c0 3.3 2.7 6 6 6s6-2.7 6-6v-2" stroke={color} {...stroke} />
      <path d="M12 14v3" stroke={color} {...stroke} />
      <path d="M10 20h4" stroke={color} {...stroke} />
      <path d="M11.5 12.5h1" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M10 8.5c0-.8.7-1.5 2-1.5" stroke={color} {...stroke} />
    </svg>
  ),
  statPendingEarnings: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="8" stroke={color} {...stroke} />
      <path d="M12 8v4.5l2.5 1.5" stroke={color} {...stroke} />
    </svg>
  ),

  navDashboard: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5z" stroke={color} {...stroke} />
    </svg>
  ),
  navReferrals: ({ size, color = THEME }) => icons.statTotalReferrals({ size, color }),
  navReports: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="4" y="12" width="4" height="8" rx="1" stroke={color} {...stroke} />
      <rect x="10" y="8" width="4" height="12" rx="1" stroke={color} {...stroke} />
      <rect x="16" y="4" width="4" height="16" rx="1" stroke={color} {...stroke} />
    </svg>
  ),
  navEarnings: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke={color} {...stroke} />
      <path d="M12 7v10M9.5 9.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5c0 1.4-2.5 2-2.5 3.5" stroke={color} {...stroke} />
    </svg>
  ),
  navPayouts: ({ size, color = THEME }) => icons.statTotalRevenue({ size, color }),
  navMarketing: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M4 11v2l14 5V6L4 11z" stroke={color} {...stroke} />
      <path d="M20 8v8" stroke={color} {...stroke} />
    </svg>
  ),
  navPackages: ({ size, color = THEME }) => icons.extraGift({ size, color }),
  navSettings: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3" stroke={color} {...stroke} />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" stroke={color} {...stroke} />
    </svg>
  ),
  navSupport: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M4 14a8 8 0 0 1 16 0v3a2 2 0 0 1-2 2h-1v-5" stroke={color} {...stroke} />
      <path d="M6 19h2M16 19h2" stroke={color} {...stroke} />
    </svg>
  ),

  perfClicks: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M5 4l4 14 2-6 7-2L5 4z" stroke={color} {...stroke} />
      <path d="M14.5 12.5 18 16" stroke={color} {...stroke} />
    </svg>
  ),
  perfRegistrations: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="10" cy="8" r="3" stroke={color} {...stroke} />
      <path d="M4 19c0-3 2.7-5.5 6-5.5" stroke={color} {...stroke} />
      <path d="M17 8v6M14 11h6" stroke={color} {...stroke} />
    </svg>
  ),
  perfConversion: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M4 17l5-7 4 3 7-10" stroke={color} {...stroke} />
      <path d="M17 3h3v3" stroke={color} {...stroke} />
    </svg>
  ),

  extraGift: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="4" y="10" width="16" height="10" rx="1.5" stroke={color} {...stroke} />
      <path d="M12 10V20M4 10h16" stroke={color} {...stroke} />
      <path d="M12 10c-2-2-4-3-4-5a2 2 0 0 1 4 0c0-2 2-3 4-5a2 2 0 0 1 4 0c0 2-2 3-4 5" stroke={color} {...stroke} />
    </svg>
  ),
  extraCoins: ({ size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <ellipse cx="10" cy="14" rx="6" ry="2.5" fill="#FCD34D" stroke="#F59E0B" strokeWidth="1.5" />
      <ellipse cx="10" cy="11" rx="6" ry="2.5" fill="#FDE68A" stroke="#F59E0B" strokeWidth="1.5" />
      <ellipse cx="10" cy="8" rx="6" ry="2.5" fill="#FEF3C7" stroke="#F59E0B" strokeWidth="1.5" />
      <path d="M16 6l1 2 2 .3-1.5 1.4.4 2-1.9-1-1.9 1 .4-2L13 8.3 15 8z" fill={THEME} opacity="0.7" />
    </svg>
  ),

  codeGift: ({ size, color = THEME }) => icons.extraGift({ size, color }),
  codeCopy: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="8" y="8" width="12" height="12" rx="2" stroke={color} {...stroke} />
      <path d="M6 16H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke={color} {...stroke} />
    </svg>
  ),
  codeShare: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="18" cy="5" r="2.5" stroke={color} {...stroke} />
      <circle cx="6" cy="12" r="2.5" stroke={color} {...stroke} />
      <circle cx="18" cy="19" r="2.5" stroke={color} {...stroke} />
      <path d="M8.5 11l7-4.5M8.5 13l7 4.5" stroke={color} {...stroke} />
    </svg>
  ),

  pkgStarter: ({ size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="4" fill={THEME_SOFT} />
      <path
        d="M12 7.5l1.4 2.8 3.1.3-2.3 2 .9 3L12 14.2 8.9 15.6l.9-3-2.3-2 3.1-.3L12 7.5z"
        stroke={THEME}
        {...stroke}
      />
    </svg>
  ),
  pkgPro: ({ size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="4" fill={THEME_SOFT} />
      <path d="M6 15l2.5-6h7L18 15" stroke={THEME} {...stroke} />
      <path d="M8 12h8" stroke={THEME} {...stroke} />
      <circle cx="9" cy="9" r="0.8" fill={THEME} />
      <circle cx="15" cy="9" r="0.8" fill={THEME} />
    </svg>
  ),
  pkgVip: ({ size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="4" fill={THEME_SOFT} />
      <path d="M12 6.5 16.5 12 12 17.5 7.5 12 12 6.5z" stroke={THEME} {...stroke} />
      <path d="M7.5 12h9M12 6.5v11" stroke={THEME} {...stroke} />
    </svg>
  ),
  pkgElite: ({ size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="4" fill={THEME_SOFT} />
      <path d="M8 17V11l4-3 4 3v6" stroke={THEME} {...stroke} />
      <path d="M7 17h10" stroke={THEME} {...stroke} />
      <path d="M12 8v2" stroke={THEME} {...stroke} />
    </svg>
  ),
  pkgCommission: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke={color} {...stroke} />
      <path d="M9 8c0-1.5 1.3-2.5 3-2.5s3 1 3 2.5c0 2-3 2-3 4M12 16v.5" stroke={color} {...stroke} />
    </svg>
  ),
  pkgMinDeposit: ({ size, color = GREEN }) => icons.statTotalRevenue({ size, color }),
  pkgDescription: ({ size, color = THEME_LIGHT }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M8 4h8l4 4v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" stroke={color} {...stroke} />
      <path d="M8 8h8M8 12h8M8 16h5" stroke={color} {...stroke} />
    </svg>
  ),
  pkgGetLink: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1 1" stroke={color} {...stroke} />
      <path d="M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1-1" stroke={color} {...stroke} />
    </svg>
  ),

  refUser: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="3.5" stroke={color} {...stroke} />
      <path d="M5 20c0-4 3.1-7 7-7s7 3 7 7" stroke={color} {...stroke} />
    </svg>
  ),
  refVerified: ({ size, color = GREEN }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" stroke={color} {...stroke} />
      <path d="M9 12l2 2 4-4" stroke={color} {...stroke} />
    </svg>
  ),
  refPending: ({ size, color = ORANGE }) => icons.statPendingEarnings({ size, color }),
  refJoined: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="4" y="5" width="16" height="15" rx="2" stroke={color} {...stroke} />
      <path d="M8 3v4M16 3v4M4 10h16" stroke={color} {...stroke} />
    </svg>
  ),

  shareLink: ({ size, color = THEME }) => icons.pkgGetLink({ size, color }),

  shareFacebook: ({ size, color = '#ffffff' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M13.2 8.2h2.3V5.4h-2.3c-2.4 0-3.9 1.5-3.9 4.2V12H7v2.9h2.3v7.4h3.2v-7.4h3.1l.5-2.9h-3.4V9.4c0-.9.5-1.2 1.5-1.2z"
        fill={color}
      />
    </svg>
  ),
  shareTwitter: ({ size, color = '#ffffff' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M21.5 7.2c-.7.3-1.5.5-2.3.6.8-.5 1.4-1.3 1.7-2.2-.8.5-1.7.8-2.6 1-1.5-1.6-4.1-1.6-5.6 0-.9.9-1.2 2.2-.8 3.4-3.1-.2-5.9-1.6-7.7-4 .9 1.6 2.8 2.7 4.9 2.7-.8-.3-1.5-.9-1.9-1.7-.3.8 0 1.7.7 2.2-1.3 0-2.5-.4-3.6-1v.1c0 1.9 1.3 3.5 3.1 3.9-.5.1-1 .2-1.5.1.4 1.3 1.6 2.2 3 2.2-1.1.9-2.5 1.4-4 1.4-.3 0-.6 0-.9-.1 1.4.9 3.1 1.5 4.9 1.5 5.9 0 9.1-4.9 9.1-9.1v-.4c.7-.5 1.2-1.1 1.7-1.8z"
        fill={color}
      />
    </svg>
  ),
  shareWhatsapp: ({ size, color = '#ffffff' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 3.5a8.5 8.5 0 0 0-7.3 12.8L3.5 20.5l4.4-1.1A8.5 8.5 0 1 0 12 3.5zm0 15.3a6.8 6.8 0 0 1-3.5-1l-.3-.1-2.5.6.7-2.4-.2-.3a6.8 6.8 0 1 1 5.3 3.2zm3.7-4.8c-.2-.1-1.3-.6-1.5-.7-.2-.1-.4-.1-.6.1-.1.1-.5.5-.6.7-.1.1-.2.2-.4.1-.2-.1-.8-.3-1.6-1-.6-.5-1-1.2-1.1-1.4-.1-.2 0-.3.1-.5.1-.1.2-.3.3-.4.1-.1.1-.2.2-.3 0-.1 0-.2-.1-.3 0-.1-.5-1.1-.7-1.5-.2-.3-.4-.4-.7-.4h-.6c-.2 0-.5.1-.6.3-.2.2-.7.7-.7 1.5 0 .9.7 1.8.8 2 .1.2 1.4 2.2 3.5 3 .5.2.9.3 1.2.3.4 0 .8-.1 1.1-.4.3-.3 1.2-1.1 1.4-1.4.2-.3 0-.5 0-.6-.1-.1-.2-.1-.4-.2z"
        fill={color}
      />
    </svg>
  ),
  shareTelegram: ({ size, color = '#ffffff' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M19.7 5.1 5.1 10.8c-1 .4-1 1-.1 1.3l3.5 1.1 1.3 4.1c.2.5.4.7.8.7.3 0 .5-.1.7-.4l1.9-1.8 3.9 2.9c.7.4 1.2.2 1.4-.7l2.3-10.8c.2-1-.3-1.5-1.2-1.1zM9 13.1l7.1-4.4c.4-.3.8-.2.5.2l-5.8 5.2-.2 2.1-1.6-3.1z"
        fill={color}
      />
    </svg>
  ),
  shareLinkCircle: ({ size, color = THEME }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M10.2 13.2a4.2 4.2 0 0 0 5.9.3l1.8-1.8a4.2 4.2 0 0 0-5.9-5.9l-.9.9"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8 10.8a4.2 4.2 0 0 0-5.9-.3l-1.8 1.8a4.2 4.2 0 0 0 5.9 5.9l.9-.9"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

const imageAssets = {
  extraGiftSolid: '/images/dashboard-kit/gift-reward.png',
  referralGiftIllustration: '/images/dashboard-kit/gift-reward.png',
  codeGift: '/images/dashboard-kit/gift-reward.png',
  shareFacebook: '/images/dashboard-kit/share-facebook.png',
  shareTwitter: '/images/dashboard-kit/share-twitter.png',
  shareWhatsapp: '/images/dashboard-kit/share-whatsapp.png',
  shareTelegram: '/images/dashboard-kit/share-telegram.png',
  shareLinkCircle: '/images/dashboard-kit/share-link.png',
};

const PartnerKitIcon = ({ name, size = 24, color, className = '', alt = '', style = {} }) => {
  const src = imageAssets[name];
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={`block object-contain shrink-0 bg-transparent ${className}`}
        style={{ width: size, height: size, background: 'transparent', ...style }}
        draggable={false}
      />
    );
  }

  const Icon = icons[name];
  if (!Icon) return null;

  return (
    <span className={`inline-flex items-center justify-center shrink-0 ${className}`} style={{ width: size, height: size }} aria-hidden={!alt}>
      <Icon size={size} color={color} />
    </span>
  );
};

export default PartnerKitIcon;
export { icons as partnerKitSvgIcons };
